import classNames from "classnames";

import styles from '../index.module.less'
import {getFileUrlPrefix} from "shj-utils";

export default function SCItem(props: { data: Record<string, any>, handleFn: (id) => void }) {
  const {data, handleFn} = props;
  const baseFile = getFileUrlPrefix()

  return <div className={styles.item_wrap_box} onClick={() => handleFn(data.code)}>
    <div className={styles.flex_start}>
      <div className={styles.icon}>
        <img src={data.icon.startsWith('http') ? data.icon : baseFile + data.icon}/>
      </div>
      <div className={styles.item_content}>
        <p className={classNames([styles.title, styles.ellipsis])}>{data.name}</p>
        <p className={classNames([styles.desc, styles.two_ellipsis])}> {data.briefIntroduce}</p>
      </div>
    </div>
  </div>
}